/*
 * @Author: Wang Wenmao
 * @Date: 2024-01-11 10:07:39
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2024-01-11 10:59:59
 * @Description: 线上下单线下付款补单 / 第三方订单补录
 */
import React, { Component } from 'react';
import {
    message,
    Card,
    Button,
    Form as AntForm,
    Input,
    Table,
    Select,
    Cascader,
    Icon,
    Row,
    Col,
    DatePicker,
    Radio,
    Modal,
} from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import moment from 'moment';
import _ from 'lodash';
import { ProductModel } from './choiseProduct';
import { AddCoupon } from './addCoupon';
import { errorHandle } from '../../services';
import './index.less';

const confirm = Modal.confirm;

const api = services.api;
const { Option } = Select;
let id = 0;
const formFaItemLayout = {
    labelCol: {
        xs: { span: 14 },
        sm: { span: 3 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 6 },
    },
};
// 商品类型
const productType = {
    GIFT: '赠品',
    SALES: '销售商品',
    FK_GIFT: '费控赠品',
    FK_POINTS: '积分商品',
    CUSTOM: '定制商品',
};

// 优惠券类型
const couponType = {
    PRODUCT: '商品金额券',
    REPAIR: '维修金额券',
    MAINTAIN: '养护金额券',
    FREIGHT: '运费券',
    RECOVER: '加价回收券',
};

const TAO_BAO = 'TAO_BAO',
    JD = 'JD',
    XHS = 'XHS',
    TIAN_MAO = 'TIAN_MAO',
    WECHAT_XIAO_DIAN = 'WECHAT_XIAO_DIAN';

const makeOrderChannelOptions = {
    [TAO_BAO]: {
        1: '淘宝PC',
        2: '淘宝手机',
    },
    [JD]: {
        1: '京东PC',
        2: '京东手机',
    },
    [XHS]: {
        1: '小红书PC',
        2: '小红书手机',
    },
    [TIAN_MAO]: {
        1: '天猫PC',
        2: '天猫手机',
    },
    [WECHAT_XIAO_DIAN]: {
        1: '微信小店',
    },
};

const tbMerchantChannelData = {
    [TAO_BAO]: [
        { name: '华夏典当行', value: 'PT32' },
        { name: '品真阁', value: 'PT37' },
    ],
    [JD]: [{ name: '品真阁', value: 'PT36' }],
    [XHS]: [{ name: '品真阁', value: 'PTF7' }],
    [TIAN_MAO]: [{ name: '品真阁', value: 'PTG4' }],
    [WECHAT_XIAO_DIAN]: [{ name: '品真阁', value: 'PTK2' }],
};

const isGreaterThanZero = (price: number | string, custom: boolean = false) => {
    price = Number(price);
    if (!custom) {
        return price >= 0 ? `¥${price.toFixed(2)}` : `-  ¥${Math.abs(+price.toFixed(2))}`;
    } else {
        return `-  ¥${price.toFixed(2)}`;
    }
};

const isMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    form: FormComponentProps['form'];
}

interface IState {
    visible: boolean;
    payList: any;
    storeList: any;
    item: any;
    payTotal: any;
    totalPrice: any;
    discountPrice: any;
    provinceData: any;
    couponData: any[];
    couponPrice: number;
    pageType: string; // 页面类型 1：线上下单线下付款补单 2：第三方订单补录
    error_message: string; // 错误提示
    loading: boolean;
    useExecutePrice: string;
    strikePrice: any; // 执行价格
}

class Index extends Component<CategoryFilterAttrTableProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            visible: true,
            // 支付方式
            payList: [],
            // 门店列表
            storeList: [],
            // 所选商品组合
            item: [],
            payTotal: 0,
            totalPrice: 0, // 商品金额
            discountPrice: 0, // 订单优惠金额
            provinceData: [], // 省份数据【为了动态请求后台城市数据】
            couponData: [], // 优惠券表格数据
            couponPrice: 0, // 优惠券金额
            pageType: '1',
            error_message: '',
            loading: false,
            useExecutePrice: '', // 是否使用执行价
            strikePrice: 0,
        };
        this.clearItem = this.clearItem.bind(this);
    }

    timer = null;

    componentDidMount() {
        this.setState(
            {
                pageType: window.location.href.includes('orderSupplement') ? '1' : '2',
            },
            () => {
                this.getPayList();
                this.getStore();
                this.getProvince(0);
            }
        );
    }

    componentWillUnmount(): void {
        clearTimeout(this.timer);
    }

    // 请求支付方式
    getPayList = () => {
        api.get({}, { apiPath: `/8001/order/getPayType/offLine` })
            .then((res) => {
                this.setState({
                    payList: res,
                });
            })
            .catch(errorHandle);
    };

    // 请求门店列表数据
    getStore = () => {
        api.get({}, { apiPath: `/8001/store/findOffLineAll` })
            .then((res) => {
                this.setState({ storeList: res });
            })
            .catch(errorHandle);
    };

    // 获取一级地区名称
    getProvince = (id) => {
        api.get({ id }, { apiPath: `/805/region/findChildrenForRest` })
            .then((res: any) => {
                res.forEach((item, index) => {
                    res[index].value = item.id;
                    res[index].label = item.name;
                    res[index].isLeaf = false;
                });
                this.setState({
                    provinceData: res,
                });
            })
            .catch(errorHandle);
    };

    showModal = () => this.setState({ visible: true });
    loadData = (selectedOptions: string | any[]) => {
        const targetOption = selectedOptions[selectedOptions.length - 1];
        targetOption.loading = true;
        if (selectedOptions.length <= 2) {
            api.get(
                {
                    id: selectedOptions[selectedOptions.length - 1].id,
                },
                { apiPath: `/805/region/findChildrenForRest` }
            )
                .then((res: any) => {
                    targetOption.loading = false;
                    res.forEach((item, index) => {
                        res[index].value = item.id;
                        res[index].label = item.name;
                        res[index].isLeaf = false;
                    });
                    targetOption.children = res;
                    this.setState({
                        provinceData: [...this.state.provinceData],
                    });
                })
                .catch(errorHandle);
        }

        if (selectedOptions.length === 3) {
            targetOption.loading = false;
            targetOption.isLeaf = true;
        }
    };

    remove = (k: any) => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        form.setFieldsValue({
            keys: keys.filter((key: any) => key !== k),
        });
    };

    add = () => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(id++);
        form.setFieldsValue({
            keys: nextKeys,
        });
    };

    /**
     * @description 选择商品回调
     * @param value 选择的商品
     * @param type 操作类型 push:添加商品  delete:删除商品
     */
    getSubmit = (value: any, type: string) => {
        this.setState(
            {
                payTotal: 0,
                totalPrice: 0,
                discountPrice: 0,
                couponPrice: 0,
                couponData: [],
                strikePrice: 0,
            },
            () => {
                let { item, payTotal, totalPrice, strikePrice } = this.state;
                if (type === 'delete') {
                    item = item.filter((el: { date: any }) => el.date !== value.date);
                } else {
                    item.push(value);
                }
                item.forEach((el: any) => {
                    payTotal = payTotal + Number(el.discountPrice); //订单支付金额
                    totalPrice = totalPrice + el.quantity * el.originPrice;
                    // 如果使用执行价
                    if (this.state.useExecutePrice === 'true') {
                        strikePrice = strikePrice + el.quantity * el.executePrice;
                    } else if (this.state.useExecutePrice === 'false') {
                        strikePrice = strikePrice + el.quantity * el.originPrice;
                    }
                });
                this.setState({
                    item,
                    payTotal,
                    totalPrice,
                    strikePrice,
                    discountPrice: totalPrice - payTotal,
                });
            }
        );
    };

    delete = (record: { skuCode: any }) => {
        const { item } = this.state;
        item.forEach((item1: { skuCode: any }, index: number) => {
            if (item1.skuCode == record.skuCode) {
                this.getSubmit(record, 'delete'); //record为假象
            }
        });
    };

    goBack = () => {
        const { pageType } = this.state;
        if (pageType === '1') {
            services.navigation.goto('/trade/orderNew');
        } else {
            try {
                window.parent.location.reload();
            } catch (error) {
                throw new Error('iframe页面域名与当前页面域名不一致，无法刷新页面');
            }
        }
    };

    setErrorMessage = (msg: string) => {
        const { pageType } = this.state;
        if (pageType === '2') {
            this.setState({ error_message: msg }, () => {
                this.timer && clearTimeout(this.timer);
                this.timer = setTimeout(() => this.setState({ error_message: '' }), 3000);
            });
        }
    };

    calculateGoodsPayableAmountInCents(payTotalCents: number, couponPriceCents: number) {
        const couponPriceCentsValue = couponPriceCents * 10000;
        const payTotalCentsValue = payTotalCents * 10000;
        console.log(payTotalCents, couponPriceCents, 'payTotalCentsValue - couponPriceCentsValue');
        return (payTotalCentsValue - couponPriceCentsValue) / 10000;
    }

    // 解析表单数据并组合传给后台
    analysisForm = (values: any) => {
        const {
            item,
            payTotal,
            couponPrice,
            pageType,
            couponData,
            discountPrice,
            totalPrice,
        } = this.state;
        if (item.length == 0) {
            message.error('请先选择商品');
            this.setErrorMessage('请先选择商品');
            return;
        }
        if (+payTotal - couponPrice <= 0) {
            message.error('订单实际支付金额不能≤0，无法提交订单');
            this.setErrorMessage('订单实际支付金额不能≤0，无法提交订单');
            return;
        }

        let chuliData = [];
        if (this.state.useExecutePrice === 'true') {
            chuliData = item;
        } else {
            chuliData = item.map((item1: any) => {
                return {
                    ...item1,
                    executePrice: item1.originPrice.toString(),
                };
            });
        }

        if (payTotal - couponPrice < 0) {
            message.error('订单实际支付金额不正确，无法提交订单');
            this.setErrorMessage('订单实际支付金额不正确，无法提交订单');
            return;
        }

        let {
            address,
            deliveryLastRegionId,
            deliveryName,
            deliveryPhone,
            invoiceEmail,
            invoiceName,
            invoicePhone,
            invoiceTitle,
            invoiceType,
            makeOrderChannel,
            memberMobile,
            orderChannel,
            payShopCode,
            paymentAmount,
            paymentCode,
            realName,
            realPayTime,
            tbOrderVideoNumber,
            tradeNo,
            invoiceTitleVal,
            taxNo,
            tbOrderNumber,
            liveNumber,
            needInvoiceType,
            tbMerchantChannel,
        } = values;

        let params: any = {
            paymentRecords: [],
            address,
            deliveryLastRegionId: deliveryLastRegionId[2],
            deliveryName,
            deliveryPhone,
            invoiceEmail,
            invoiceName,
            invoicePhone,
            invoiceTitle: needInvoiceType === '1' ? invoiceTitle : '',
            invoiceType,
            makeOrderChannel,
            memberMobile,
            orderChannel,
            payShopCode,
            realName,
            realPayTime: moment(realPayTime).format('YYYY-MM-DD HH:mm:ss'),
            tbOrderVideoNumber,
            invoiceTitleVal,
            taxNo,
            items: chuliData,
            goodsAmount: totalPrice,
            goodsDiscountAmount: discountPrice,
            goodsPayableAmount: this.calculateGoodsPayableAmountInCents(payTotal, couponPrice),
            couponNos: couponData.map((el) => el.id),
            tbOrderNumber,
            liveNumber,
            tbMerchantChannel,
            couponsAmount: couponPrice,
            useExecutePrice: this.state.useExecutePrice,
        };
        if (pageType === '1') {
            //  先把页面的支付信息存到paymentRecords中
            params.paymentRecords.push({ paymentCode, paymentAmount, tradeNo });
            if (this.props.form.getFieldValue('keys').length > 0) {
                this.props.form.getFieldValue('keys').forEach((item: any) => {
                    params.paymentRecords.push({
                        paymentCode: values['paymentCode' + item],
                        paymentAmount: values['paymentAmount' + item],
                        tradeNo: values['tradeNo' + item],
                    });
                });
            }

            const sum = params.paymentRecords.reduce(
                (total, item) => total + Number(item.paymentAmount),
                0
            );

            console.log('goodsPayableAmount', params.goodsPayableAmount);
            console.log('sum', sum);
            if (params.goodsPayableAmount !== sum) {
                message.error('支付金额与订单实际支付金额不一致');
                return;
            }
        }

        const apiPath =
            this.state.pageType === '1'
                ? '/8001/order/create_offlinePay_order'
                : '/8001/order/create_tb_order';

        this.setState({ loading: true });

        api.request({ method: 'post', apiPath, params })
            .then((response: any) => {
                const res = JSON.parse(response.text);
                if (!res.result) {
                    message.error(res.tip);
                    this.setErrorMessage(res.tip);
                    return;
                }
                this.goBack();
            })
            .catch((err: any) => {
                errorHandle(err);
                const { response, status } = err;
                const msg =
                    status === undefined
                        ? '请求已被终止。'
                        : (response && response.body && response.body.err_message) || '请求失败';
                this.setErrorMessage(msg);
            })
            .finally(() => this.setState({ loading: false }));
    };

    handleSubmit = () => {
        this.props.form.validateFieldsAndScroll((_: any, values: any) => this.analysisForm(values));
    };

    getCoupon = (item: any) => {
        const { strikePrice, totalPrice } = this.state;

        const data = [...this.state.couponData];
        data.push(item);

        let couponPrice = 0;
        if (item.moneyUnit === 'SUBTRACT') {
            couponPrice = item.price;
        }
        console.log(strikePrice, item.price, 'strikePrice');
        if (item.moneyUnit === 'DISCOUNT') {
            couponPrice = this.calculateGoodsPayableAmountInCents(
                strikePrice,
                (strikePrice * 10000 * (item.price / 10)) / 10000
            );
        }

        this.setState({ couponData: data, couponPrice });
    };

    handleChangeNeedInvoice = (e) => {
        const { form } = this.props;
        if (e.target.value == '2') {
            form.setFieldsValue({
                invoiceType: '',
                invoiceTitle: '',
                invoiceTitleVal: '',
                taxNo: '',
                invoicePhone: '',
                invoiceName: '',
                invoiceEmail: '',
            });
        }
    };

    deleteCouponItem = () => {
        this.setState({ couponData: [], couponPrice: 0 });
    };

    handleResetTbMerchantChannel = () => {
        this.props.form.setFieldsValue({ tbMerchantChannel: undefined });
    };

    // 第三方订单信息
    renderExternalOrderInfo = () => {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        const renderTbMerchantChannel = () => {
            const orderChannel = getFieldValue('orderChannel');

            return (
                <AntForm.Item label="店铺渠道">
                    {getFieldDecorator('tbMerchantChannel', {
                        rules: [{ required: true, message: '店铺渠道' }],
                    })(
                        <Select placeholder="请选择">
                            {tbMerchantChannelData[orderChannel].map((el) => (
                                <Option key={el.value} value={el.value}>
                                    {el.name}
                                </Option>
                            ))}
                        </Select>
                    )}
                </AntForm.Item>
            );
        };

        return (
            <Card type="inner" title="第三方订单信息">
                <AntForm {...formFaItemLayout}>
                    <AntForm.Item label="订单类型">
                        {getFieldDecorator('orderChannel', {
                            initialValue: TAO_BAO,
                            rules: [{ required: true, message: '请选择订单类型' }],
                        })(
                            <Select
                                placeholder="请选择"
                                onSelect={this.handleResetTbMerchantChannel}
                            >
                                <Option value={TAO_BAO}>淘宝订单</Option>
                                <Option value={JD}>京东订单</Option>
                                <Option value={XHS}>小红书订单</Option>
                                <Option value={TIAN_MAO}>天猫订单</Option>
                                <Option value={WECHAT_XIAO_DIAN}>微信小店</Option>
                            </Select>
                        )}
                    </AntForm.Item>
                    <AntForm.Item label="下单终端">
                        {getFieldDecorator('makeOrderChannel', {
                            initialValue: '1',
                            rules: [{ required: true, message: '请选择下单终端' }],
                        })(
                            <Select
                                placeholder="请选择"
                                onSelect={this.handleResetTbMerchantChannel}
                            >
                                {makeOrderChannelOptions[getFieldValue('orderChannel')] &&
                                    Object.keys(
                                        makeOrderChannelOptions[getFieldValue('orderChannel')]
                                    ).map((key) => (
                                        <Option value={key}>
                                            {
                                                makeOrderChannelOptions[
                                                    getFieldValue('orderChannel')
                                                ][key]
                                            }
                                        </Option>
                                    ))}
                            </Select>
                        )}
                    </AntForm.Item>

                    <AntForm.Item label="第三方订单号">
                        {getFieldDecorator('tbOrderNumber', {
                            rules: [{ required: true, message: '请输入第三方订单号' }],
                        })(<Input placeholder="请填写第三方订单号" />)}
                    </AntForm.Item>

                    <AntForm.Item label="会员手机号">
                        {getFieldDecorator('memberMobile', {
                            rules: [
                                { required: true, message: '请输入会员手机号' },
                                { pattern: isMobile, message: '手机号格式不正确' },
                            ],
                        })(<Input placeholder="请填写会员手机号" />)}
                    </AntForm.Item>

                    <AntForm.Item label="会员真实姓名">
                        {getFieldDecorator('realName')(<Input placeholder="请填写会员真实姓名" />)}
                    </AntForm.Item>

                    {renderTbMerchantChannel()}

                    <AntForm.Item label="直播人工号">
                        {getFieldDecorator('liveNumber')(<Input placeholder="请填写直播人工号" />)}
                    </AntForm.Item>
                </AntForm>
            </Card>
        );
    };

    // 订单信息
    renderOrderDetails = () => {
        const { getFieldDecorator } = this.props.form;
        const { storeList } = this.state;
        return (
            <Card style={{ marginTop: 16 }} type="inner" title="订单信息">
                <AntForm {...formFaItemLayout}>
                    <AntForm.Item label="订单类型">
                        {getFieldDecorator('orderChannel', {
                            initialValue: 'MINI_PROGRAM ',
                            rules: [{ required: true, message: '请选择订单类型' }],
                        })(
                            <Select placeholder="请选择">
                                <Option value="MINI_PROGRAM ">销售订单</Option>
                            </Select>
                        )}
                    </AntForm.Item>
                    <AntForm.Item label="下单终端">
                        {getFieldDecorator('makeOrderChannel', {
                            rules: [{ required: true, message: '请选择下单终端' }],
                            initialValue: '3',
                        })(
                            <Select placeholder="请选择">
                                <Option value="3">管理端</Option>
                            </Select>
                        )}
                    </AntForm.Item>
                    {this.rederPay()}
                    <AntForm.Item label="收款门店">
                        {getFieldDecorator('payShopCode', {
                            rules: [{ required: true, message: '请选择收款门店' }],
                        })(
                            <Select placeholder="请选择">
                                {storeList &&
                                    storeList.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                            </Select>
                        )}
                    </AntForm.Item>
                    <AntForm.Item label="收款时间">
                        {getFieldDecorator('realPayTime', {
                            rules: [{ required: true, message: '请选择实际收款时间' }],
                            initialValue: moment(),
                        })(<DatePicker showTime />)}
                    </AntForm.Item>
                    <AntForm.Item label="会员手机号">
                        {getFieldDecorator('memberMobile', {
                            rules: [
                                { required: true, message: '请输入会员手机号' },
                                { pattern: isMobile, message: '手机号格式不正确' },
                            ],
                        })(<Input placeholder="请填写会员手机号" />)}
                    </AntForm.Item>
                    <AntForm.Item label="会员姓名">
                        {getFieldDecorator('realName')(<Input placeholder="请填写会员姓名" />)}
                    </AntForm.Item>
                    <AntForm.Item label="推荐人(员工编号)">
                        {getFieldDecorator('tbOrderVideoNumber')(
                            <Input placeholder="请填写推荐人(员工编号)" />
                        )}
                    </AntForm.Item>
                </AntForm>
            </Card>
        );
    };

    // 收货人信息
    renderRecipientInfo = () => {
        const { getFieldDecorator } = this.props.form;
        const { provinceData } = this.state;
        return (
            <Card style={{ marginTop: 16 }} type="inner" title="收货人信息">
                <AntForm {...formFaItemLayout}>
                    <AntForm.Item label="收货方式">
                        <div>配送(顺丰)</div>
                    </AntForm.Item>
                    <AntForm.Item label="收货人">
                        {getFieldDecorator('deliveryName', {
                            rules: [{ required: true, message: '请输入收货人' }],
                        })(<Input placeholder="请填写收货人" />)}
                    </AntForm.Item>
                    <AntForm.Item label="手机号">
                        {getFieldDecorator('deliveryPhone', {
                            rules: [
                                { required: true, message: '请输入手机号' },
                                { pattern: isMobile, message: '手机号格式不正确' },
                            ],
                        })(<Input placeholder="请填写手机号" />)}
                    </AntForm.Item>
                    <AntForm.Item label="所在地区">
                        {getFieldDecorator('deliveryLastRegionId', {
                            rules: [{ required: true, message: '请选择所在地区' }],
                        })(
                            <Cascader
                                options={provinceData}
                                loadData={this.loadData}
                                changeOnSelect
                            />
                        )}
                    </AntForm.Item>
                    <AntForm.Item label="详细地址">
                        {getFieldDecorator('address', {
                            rules: [{ required: true, message: '请输入详细地址' }],
                        })(<Input placeholder="请填写详细地址" />)}
                    </AntForm.Item>
                </AntForm>
            </Card>
        );
    };

    clearItem = (e: { target: { value: any } }) => {
        this.setState({
            useExecutePrice: e.target.value,
            item: [],
        });
    };

    onChangeUseExecutePrice = (e: any) => {
        if (!!this.state.item.length) {
            const that = this;
            confirm({
                title: '切换是否使用执行价',
                content: '切换是否使用当前执行价将清空商品明细，是否继续操作？',
                centered: true,
                onOk() {
                    that.clearItem(e);
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        } else {
            this.setState({
                useExecutePrice: e.target.value,
            });
        }
    };

    // 商品明细及促销信息
    renderProductDetailsAndPromotions = () => {
        const { item } = this.state;
        const columns = [
            {
                title: '商品类型',
                dataIndex: 'skuType',
                key: 'skuType',
                render: (_: any, record: any) => <span>{productType[record.skuType]}</span>,
            },
            {
                title: 'SKU',
                dataIndex: 'skuCode',
                key: 'skuCode',
            },
            {
                title: 'SKN',
                dataIndex: 'address',
                key: 'address',
            },
            {
                title: '商品名称',
                dataIndex: 'productName',
                key: 'productName',
            },
            {
                title: '数量',
                dataIndex: 'quantity',
                key: 'quantity',
            },
            {
                title: '重量',
                dataIndex: 'weight',
                key: 'weight',
            },
            {
                title: '电商原价',
                dataIndex: 'originPrice',
                key: 'originPrice',
            },
            {
                title: '执行价',
                dataIndex: 'executePrice',
                key: 'executePrice',
            },
            {
                title: '商品项总价',
                dataIndex: 'discountPrice',
                key: 'discountPrice',
            },
            {
                title: '操作',
                key: 'action',
                render: (_: any, record: any) => (
                    <span>
                        <a onClick={this.delete.bind(this, record)}>删除</a>
                    </span>
                ),
            },
        ];

        return (
            <Card style={{ marginTop: 16 }} type="inner" title="商品明细及促销信息">
                {/* 选择商品弹框 */}
                <ProductModel
                    useExecutePrice={this.state.useExecutePrice}
                    submit={(value: any) => this.getSubmit(value, 'push')}
                />
                <div style={{ margin: '16px 0' }}>
                    是否使用执行价：
                    <Radio.Group
                        onChange={this.onChangeUseExecutePrice}
                        value={this.state.useExecutePrice}
                    >
                        <Radio value={'true'}>使用</Radio>
                        <Radio value={'false'}>不使用</Radio>
                    </Radio.Group>
                </div>
                {/* 商品明细表格 */}
                <Table rowKey="date" dataSource={item} columns={columns} />
            </Card>
        );
    };

    // 优惠券
    renderDiscountCoupon = () => {
        const { item, couponData, couponPrice } = this.state;
        const { form } = this.props;
        const mobile = form.getFieldValue('memberMobile');
        const isShow = isMobile.test(mobile) && Object.keys(item).length;

        const columns = [
            {
                title: '优惠券类型',
                dataIndex: 'type',
                key: 'type',
                render: (text: string) => {
                    return <div>{couponType[text]}</div>;
                },
            },
            {
                title: '优惠券名称',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '优惠券ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '优惠券有效期',
                dataIndex: 'time',
                key: 'time',
                render: (_: string, record: any) => {
                    return (
                        <div>
                            {record.beginTime} 至 {record.endTime}
                        </div>
                    );
                },
            },
            {
                title: '使用门槛',
                dataIndex: 'conditionValue',
                key: 'conditionValue',
                render: (_: any, record: any) => (
                    <div>
                        满{record.conditionValue}
                        {record.condition === 'GRAM' || record.condition === 'MONEY' ? '元' : '件'}
                        可用
                    </div>
                ),
            },
            {
                title: '优惠额度/折扣力度',
                key: 'preferential',
                render: (_: any, record: any) => {
                    const types = {
                        SUBTRACT: `减¥${record.price}元`,
                        DISCOUNT: `打${record.price}折`,
                    };
                    return <div>{types[record.moneyUnit]}</div>;
                },
            },
            {
                title: '操作',
                key: 'action',
                render: (_: any, record: any) => (
                    <span>
                        <Button type="link" onClick={this.deleteCouponItem.bind(this)}>
                            删除
                        </Button>
                    </span>
                ),
            },
        ];

        return (
            <Card style={{ marginTop: 16 }} type="inner" title="优惠券">
                <p>优惠券总额:&nbsp;&nbsp;&nbsp;&nbsp;{isGreaterThanZero(couponPrice)}</p>
                {/* 添加优惠券弹框 */}
                {isShow ? (
                    <AddCoupon
                        coupons={couponData.map((el) => el.id)}
                        mobile={form.getFieldValue('memberMobile')}
                        item={item}
                        submit={(keys: string[]) => this.getCoupon(keys)}
                        useExecutePrice={this.state.useExecutePrice}
                    />
                ) : (
                    <Button style={{ marginBottom: 16 }} type="primary" disabled={true}>
                        添加优惠券
                    </Button>
                )}
                {/* 优惠券明细表格 */}
                <Table rowKey="id" dataSource={couponData} columns={columns} />
            </Card>
        );
    };

    // 发票信息
    renderInvoiceDetails = () => {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        return (
            <Card style={{ marginTop: 16 }} type="inner" title="发票信息">
                <AntForm {...formFaItemLayout}>
                    <AntForm.Item label="是否开发票">
                        {getFieldDecorator('needInvoiceType', {
                            initialValue: '1',
                            rules: [{ required: true }],
                        })(
                            <Radio.Group
                                buttonStyle="solid"
                                onChange={this.handleChangeNeedInvoice}
                            >
                                <Radio.Button value="1">开发票</Radio.Button>
                                <Radio.Button value="-1">不开发票</Radio.Button>
                            </Radio.Group>
                        )}
                    </AntForm.Item>
                    {getFieldValue('needInvoiceType') == '1' && (
                        <>
                            <AntForm.Item label="抬头类型">
                                {getFieldDecorator('invoiceTitle', {
                                    initialValue: 'ENTERPRISE',
                                    rules: [{ required: true, message: '请选择发票抬头' }],
                                })(
                                    <Radio.Group>
                                        <Radio value="ENTERPRISE">企业</Radio>
                                        <Radio value="PERSONAL">个人</Radio>
                                    </Radio.Group>
                                )}
                            </AntForm.Item>
                            <AntForm.Item label="发票类型">
                                {getFieldDecorator('invoiceType', {
                                    initialValue: '1',
                                })(<div>普通增值税发票</div>)}
                            </AntForm.Item>
                            {getFieldValue('invoiceTitle') == 'ENTERPRISE' ? (
                                <>
                                    <AntForm.Item label="公司主体">
                                        {getFieldDecorator('invoiceTitleVal', {
                                            rules: [{ required: true, message: '请输入公司主体' }],
                                        })(<Input placeholder="请填写公司主体" />)}
                                    </AntForm.Item>
                                    <AntForm.Item label="纳税人识别号">
                                        {getFieldDecorator('taxNo', {
                                            rules: [
                                                { required: true, message: '请输入纳税人识别号' },
                                            ],
                                        })(<Input placeholder="请填写纳税人识别号" />)}
                                    </AntForm.Item>
                                </>
                            ) : (
                                <AntForm.Item label="收票人姓名">
                                    {getFieldDecorator('invoiceName', {
                                        rules: [{ required: true, message: '请输入收票人姓名' }],
                                    })(<Input placeholder="请填写收票人姓名" />)}
                                </AntForm.Item>
                            )}

                            <AntForm.Item label="收票人手机">
                                {getFieldDecorator('invoicePhone', {
                                    rules: [
                                        { required: true, message: '请输入收票人手机' },
                                        { pattern: isMobile, message: '手机号格式不正确' },
                                    ],
                                })(<Input placeholder="收票人手机号码" />)}
                            </AntForm.Item>
                            <AntForm.Item label="收票人邮箱">
                                {getFieldDecorator('invoiceEmail', {
                                    rules: [
                                        {
                                            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                                            message: '邮箱格式不正确',
                                        },
                                    ],
                                })(<Input type="email" placeholder="收票人电子邮箱" />)}
                            </AntForm.Item>
                        </>
                    )}
                </AntForm>
            </Card>
        );
    };

    rederPay = () => {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { payList } = this.state;
        getFieldDecorator('keys', { initialValue: [] });
        const keys = getFieldValue('keys');
        const formItems = keys.map((k: any) => (
            <AntForm className="ant-advanced-search-form">
                <Row gutter={24}>
                    <Col span={6}>
                        <AntForm.Item label="支付方式">
                            {getFieldDecorator(`paymentCode${k}`, {
                                rules: [{ required: true, message: '请选择支付方式' }],
                            })(
                                <Select placeholder="请选择">
                                    {payList &&
                                        payList.map((item: any) => {
                                            return <Option value={item.id}>{item.name}</Option>;
                                        })}
                                </Select>
                            )}
                        </AntForm.Item>
                    </Col>
                    <Col span={6}>
                        <AntForm.Item label="流水号">
                            {getFieldDecorator(`tradeNo${k}`, {
                                rules: [{ required: true, message: '请输入流水号' }],
                            })(<Input placeholder="请填写流水号" />)}
                        </AntForm.Item>
                    </Col>
                    <Col span={6}>
                        <AntForm.Item label="支付金额">
                            {getFieldDecorator(`paymentAmount${k}`, {
                                rules: [{ required: true, message: '请输入支付金额' }],
                            })(<Input placeholder="请填写支付金额" />)}
                        </AntForm.Item>
                    </Col>
                    <Icon
                        className="dynamic-delete-button"
                        type="minus-circle-o"
                        onClick={() => this.remove(k)}
                    />
                </Row>
            </AntForm>
        ));
        return (
            <>
                <AntForm className="ant-advanced-search-form">
                    <Row gutter={24}>
                        <Col span={6}>
                            <AntForm.Item label="支付方式">
                                {getFieldDecorator('paymentCode', {
                                    rules: [{ required: true, message: '请选择支付方式' }],
                                })(
                                    <Select placeholder="请选择">
                                        {payList &&
                                            payList.map((item) => {
                                                return (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </Option>
                                                );
                                            })}
                                    </Select>
                                )}
                            </AntForm.Item>
                        </Col>
                        <Col span={6}>
                            <AntForm.Item label="流水号">
                                {getFieldDecorator('tradeNo', {
                                    rules: [{ required: true, message: '请输入流水号' }],
                                })(<Input placeholder="请填写流水号" />)}
                            </AntForm.Item>
                        </Col>
                        <Col span={6}>
                            <AntForm.Item label="支付金额">
                                {getFieldDecorator('paymentAmount', {
                                    rules: [{ required: true, message: '请输入支付金额' }],
                                })(<Input placeholder="请填写支付金额" />)}
                            </AntForm.Item>
                        </Col>
                        <Icon
                            type="plus-circle"
                            style={{ fontSize: '20px' }}
                            onClick={() => this.add()}
                        />
                    </Row>
                    {formItems}
                </AntForm>
            </>
        );
    };

    render() {
        const {
            payTotal,
            totalPrice,
            discountPrice,
            couponPrice,
            pageType,
            error_message,
            loading,
        } = this.state;

        return (
            <div
                id="orderSupplementView"
                className={pageType === '1' ? 'order-supplement-view' : ''}
                style={{ background: '#fff' }}
            >
                <div
                    className="order-supplement-view-title"
                    style={{
                        marginBottom: pageType === '1' ? 0 : 15,
                    }}
                >
                    {pageType === '1' ? '线上下单线下付款补单' : '第三方订单补录'}
                </div>
                {pageType === '1' ? this.renderOrderDetails() : this.renderExternalOrderInfo()}
                {this.renderRecipientInfo()}
                {this.renderProductDetailsAndPromotions()}
                {this.renderDiscountCoupon()}
                {this.renderInvoiceDetails()}
                <Card style={{ marginTop: 16 }} type="inner">
                    <p>商品总额:&nbsp;&nbsp;&nbsp;&nbsp;{isGreaterThanZero(totalPrice)}</p>
                    <p>
                        优惠券金额:&nbsp;&nbsp;&nbsp;&nbsp;
                        {isGreaterThanZero(couponPrice, true)}
                    </p>
                    <p>
                        订单优惠金额:&nbsp;&nbsp;&nbsp;&nbsp;
                        {isGreaterThanZero(discountPrice)}
                    </p>
                    <p>
                        实际支付金额:&nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{ color: 'red' }}>
                            {isGreaterThanZero(+payTotal - couponPrice)}
                        </span>
                        <span
                            id="errMessage"
                            style={{ color: 'red', marginLeft: 20, fontSize: 20 }}
                        >
                            {error_message}
                        </span>
                    </p>
                </Card>
                <AntForm.Item style={{ marginTop: '30px' }}>
                    <Button type="primary" loading={loading} onClick={this.handleSubmit}>
                        提交
                    </Button>
                    <Button style={{ marginLeft: 50 }} onClick={this.goBack}>
                        取消
                    </Button>
                </AntForm.Item>
            </div>
        );
    }
}

export const OrderSupplementView = AntForm.create<CategoryFilterAttrTableProps>()(Index);
